import { useState, useEffect } from 'react';
import Modal from '@components/widgets/Modal';
import Button from '@components/forms/Button';
import dashboard from '@assets/images/dashboard.png';

const STORAGE_KEY_PREFIX = 'welcome_modal_dismissed_';

interface Props {
  firstName: string;
}

const WelcomeModal = ({ firstName }: Props) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const userId = localStorage.getItem('userId') || 'guest';
    const dismissed = localStorage.getItem(`${STORAGE_KEY_PREFIX}${userId}`);
    if (!dismissed) {
      setOpen(true);
    }
  }, []);

  const handleClose = () => {
    const userId = localStorage.getItem('userId') || 'guest';
    localStorage.setItem(`${STORAGE_KEY_PREFIX}${userId}`, 'true');
    setOpen(false);
  };

  return (
    <Modal title="" size="lg" open={open} onClose={handleClose}>
      <div className="px-2 pb-2">
        {/* Image — centred at the top */}
        <div className="flex justify-center mb-6 pt-4">
          <img src={dashboard} alt="" className="object-contain h-40" />
        </div>

        {/* Welcome text */}
        <p className="text-base font-semibold text-grey-500 mb-1 text-center">Hi {firstName}!</p>
        <h2 className="text-xl font-bold text-grey-900 mb-3 text-center">Welcome to Authentik8.</h2>
        <p className="text-sm text-grey-600 leading-relaxed mb-2 text-center">
          Authentik8 streamlines the process for identity and vehicle verification. Within this portal, you can start inspections, prompting vehicle sellers to undergo the verification process.
        </p>
        <p className="text-sm text-grey-600 leading-relaxed mb-6 text-center">
          Log in at any time to track the inspection's progress and monitor identity or vehicle checks in real-time.
        </p>

        {/* Footer */}
        <div className="flex justify-center">
          <Button
            className="bg-secondary text-white normal-case font-semibold rounded-lg text-sm py-2.5 px-6 hover:bg-secondary-dark"
            onClick={handleClose}>
            Get started
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default WelcomeModal;
